<vectronic-card
  class="parameter-dialog"
  [title]="getTitle()"
  [displayClose]="true"
  (closed)="dialogRef.close()"
  [showResize]="true"
  (resized)="onResized($event)"
>
  <ng-container body>
    <vectronic-parameter-view
      [parameters]="data.parameters"
      [categories]="data.categories"
      [subsystems]="data.subsystems"
      [isFullScreen]="isFullScreen()"
      [showOnlyFactoryLabel]="true"
      [userAccess]="userAccess()"
      [deviceTypeParameterConfigWithAvailableList]="data.deviceTypeParameterConfig"
    ></vectronic-parameter-view>
  </ng-container>

  <ng-template #cardButtons>
    <div class="parameter-dialog__allOrCustomer">
      <mat-button-toggle-group [value]="allOrCustomer()" (change)="onChangeAllOrCustomer($event)">
        <mat-button-toggle value="customer">Customer</mat-button-toggle>
        <mat-button-toggle value="all">All</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </ng-template>
</vectronic-card>
